<template>
  <div class="login-sms">
    <c-nav></c-nav>
    <div class="a-page-head">
      <div class="a-page-title">验证手机号</div>
    </div>

    <c-input label="手机号码" placeholder="请输入手机号" v-model="phone"></c-input>

    <c-input label="验证码" placeholder="请输入验证码" v-model="code" noclear>
      <div v-if="seconds > 0" class="a-text-16 a-gray">{{ seconds }}秒后重试</div>
      <div v-else class="a-text-16 a-blue" @click="onSend">发送验证码</div>
    </c-input>

    <div class="a-btn-line a-fix-bottom">
      <div class="a-btn" @click="onSubmit">验 证</div>
    </div>
  </div>
</template>

<script>
import validate from "../../utils/validate";
import API from "../../api";
import auth from "../web";
import localStorage from "../../utils/localStorage";

export default {
  data() {
    return {
      phone: "",
      code: "",
      seconds: 0
    };
  },

  beforeDestroy() {
    clearTimeout(this._timer);
  },

  methods: {
    alert(message) {
      this.$notify({
        message
      });
    },

    countdown() {
      const seconds = ~~((this._till - new Date().getTime()) / 1000);

      if (seconds > 0) {
        this.seconds = seconds;
        this._timer = setTimeout(() => {
          this.countdown();
        }, 1000);
      } else {
        this.seconds = 0;
      }
    },

    onSend() {
      if (this.seconds > 0) {
        return;
      }

      if (!validate.phone(this.phone)) {
        this.alert("请输入正确的手机号");
        return;
      }

      clearTimeout(this._timer);

      this.$withLoading(API.login["4101"])({
        phone: this.phone
      })
        .then(auth.handleLoginRes("RequestCodeError"))
        .then(() => {
          this._till = new Date().getTime() + 60 * 1000;
          this.countdown();
        })
        .catch(e => {
          this.alert(e.message || "抱歉，我们遇到一点问题，请您稍后再试。");
        });
    },

    onSubmit() {
      if (!this.code) {
        this.alert("请输入验证码");
        return;
      }

      this.$withLoading(API.login["41021"])({
        phone: this.phone,
        code: this.code
      })
        .then(auth.handleLoginRes("RequestCodeError"))
        .then(r => {
          localStorage.set("authcode", r.authcode);
          localStorage.set("refreshcode", r.refreshcode);
          localStorage.set("authExpiretime", r.authExpiretime);
          localStorage.set("refreshExpiretime", r.refreshExpiretime);
          localStorage.set("user", r.user);

          let ptid = localStorage.get("ptid") || "";
          if (
            ptid === "quickapp" &&
            system &&
            system.postMessage &&
            typeof system.postMessage === "function"
          ) {
            let message = {
              authcode: r.authcode,
              refreshcode: r.refreshcode
            };
            system.postMessage(JSON.stringify(message));
          }
        })
        .then(() => {
          this.done();
        })
        .catch(e => {
          this.alert(e.message || "网络服务异常，请稍候再试");
        });
    },

    done() {
      const { ru = "", rp = "", refresh = "", callback = null } =
        this.$route.params || {};

      if (ru) {
        console.log(`ru: ${ru},rp: ${rp},refresh: ${refresh}`);

        // 如果已经加载了页面，就用单页跳转，否则用location
        const matched = this.$router.getMatchedComponents(rp);

        console.log("matched:", matched);

        if (rp && matched && matched.length > 0 && !refresh) {
          this.handleCallBack(callback);
          this.$router.replace(rp);
        } else {
          this.handleCallBack(callback);
          location.replace(ru);
        }
      } else {
        this.handleCallBack(callback);
        this.$router.back();
      }
    },

    handleCallBack(fn) {
      if (fn && typeof fn === "function") {
        fn();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/auth/login/sms.vue